import XDownloader from './Classes/XDownloader';
import ResponsiveTable from './Classes/ResponsiveTable';
import ListTable from './Classes/ListTable';


let xdonwloaderInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {
  // console.log("script.min.js", 'loaded');

  new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 998,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
});

  xdonwloaderInstance = new XDownloader({
    tableTitle: 'Bystronic -',
    tableSelector: '.ns-table-wrap',
    tableCellFormatter: function(td) { return td.innerText.trim()},
    // excludeTableSelector,
    downloadText: ' ', // Text for downloadbutton, can be empty if you want to use an icon
    styles: [
      {
        class: 'head',
        font: {
          bold: true,
          color: {
            argb: 'FF000000'
          }
        },
        head: true,
        index: 10
      },
      {
        class: 'ns-borderbottom-bline',
        // font: {
        //   bold: true
        // },
        border: {
          bottom: {
            style: 'medium',
            color: {
              argb: 'FF000000'
            }
          },
        },
      },
      {
        class: 'ns-borderbottom-line',
        border: {
          bottom: {
            style: 'thin',
            color: {
              argb: 'FF000000'
            }
          },
        },
      },
      {
        class: 'ns-backgroundcolortint-10000',
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: 'FFF4ECDB'
          }
        }
      }

    ], // cell Styles from classes
    // numFmt, // numFmt overwrite for custom formatting
    // mergeStrings, // Set mergeStrings for all Tables
    // tableCellFormatter,
  });

  new ListTable();
});
